import React from 'react';

import { TextField } from '@mui/material';

export default function TextAreaInput(props) {
  return <TextField {...props} multiline rows={3} />;
}
